import React from "react";
import { Box, Button, TextField } from "@mui/material";
import { useFormik } from "formik";
import * as yup from "yup";
import Header from "../../AdminComponents/Header";
import { useDispatch } from "react-redux";
import { AddServiceLocation } from "../../../../context/Slice/VendorManagementSlice";

const CreateServiceLocation = ({ handleFormClose, refreshLocationList }) => {
  const dispatch = useDispatch();

  const validationSchema = yup.object({
    LocationName: yup.string().required("Location Name is required"),
  });

  const formik = useFormik({
    initialValues: {
      LocationName: "",
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      const response = await dispatch(AddServiceLocation(values));
      if (response.payload) {
        console.log("response", response.payload);
        refreshLocationList();
        handleFormClose();
      } else {
        console.error("Failed to add service location");
      }
    },
  });

  return (
    <Box m="20px">
      <Header title="Add New Location" subtitle="Add a new location" />

      <form autoComplete="off" onSubmit={formik.handleSubmit}>
        <Box
          display="grid"
          gap="30px"
          gridTemplateColumns="repeat(4, minmax(0, 1fr))"
        >
          <TextField
            fullWidth
            variant="filled"
            type="text"
            label="Location Name"
            name="LocationName"
            value={formik.values.LocationName}
            onChange={formik.handleChange}
            error={formik.touched.LocationName && Boolean(formik.errors.LocationName)}
            helperText={formik.touched.LocationName && formik.errors.LocationName}
            InputLabelProps={{ style: { fontSize: 17 } }}
            inputProps={{ style: { fontSize: 20 } }}
            sx={{ gridColumn: "span 2" }}
          />
        </Box>
        <Box display="flex" justifyContent="center" mt="20px">
          <Button type="submit" variant="contained" className="primary fs-4" sx={{ mr: 2 }}>
            Add
          </Button>
          <Button type="button" variant="contained" className="primary fs-4" onClick={handleFormClose}>
            Back
          </Button>
        </Box>
      </form>
    </Box>
  );
};

export default CreateServiceLocation;